import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoSchedule from "../../components/BookDemo/thankyouPage199Google/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/thankyouPage199Google/SuccessMessage";

import { initGA, initGtm, initPixel } from "../../helpers/CampaignEvents";


const ThankYouPage199Google = () => {
  const { component } = useParams();

  useEffect(() => {
    initGA()
  }, [])

  console.log(component)
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessage />
          ) :(
            <DemoSchedule />

          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage199Google;
